import { createContext } from 'react';

const CompactTopicsContext = createContext(false);

export default CompactTopicsContext;
